import React, { useId } from 'react'
import './Input.css'

const Input = ({
  as = 'input',
  type = 'text',
  placeholder = '',
  value = '',
  onChange,
  disabled = false,
  error = false,
  label = '',
  id = '',
  className = '',
  ...props
}) => {
  // NEW: React ka built-in useId() hook — agar koi id prop pass nahi hui,
  // to ye automatically ek unique, stable id generate kar deta hai.
  // Isse label aur input/textarea hamesha connected rahenge, chahe
  // koi bhi page id pass karna bhool jaye.
  const generatedId = useId()
  const inputId = id || generatedId

  const classes = [
    'input',
    error && 'input-error',
    disabled && 'input-disabled',
    className
  ].filter(Boolean).join(' ')

  // NEW: as="textarea" ab actually <textarea> render karta hai,
  // pehle ye sirf ek ignore-hone-wala attribute tha <input> pe.
  const Element = as === 'textarea' ? 'textarea' : 'input'

  return (
    <div className="input-wrapper">
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
        </label>
      )}
      <Element
        // type attribute textarea pe invalid hota hai, isliye sirf
        // input ke case mein pass karo
        {...(Element === 'input' ? { type } : {})}
        id={inputId}
        className={classes}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      {error && <span className="input-error-message">{error}</span>}
    </div>
  )
}

export default Input